import { useState } from 'react';

/** The maps' discrete zoom steps, 1× being the whole drawing in view. */
export const ZOOM_STEPS = [1, 1.5, 2] as const;
export type ZoomStep = (typeof ZOOM_STEPS)[number];

export interface IZoomSteps {
  zoom: ZoomStep;
  /** The next step in or out; undefined at either end. */
  larger: ZoomStep | undefined;
  smaller: ZoomStep | undefined;
  setZoom(step: ZoomStep): void;
}

export function useZoomSteps(): IZoomSteps {
  const [zoom, setZoom] = useState<ZoomStep>(ZOOM_STEPS[0]);
  return {
    zoom,
    larger: ZOOM_STEPS.find((step) => step > zoom),
    smaller: ZOOM_STEPS.findLast((step) => step < zoom),
    setZoom,
  };
}
